const NotFound = () => <p>Page Not Found 404! (botID is invalid)</p>;

export default NotFound;
